import { inject, observer } from 'mobx-react';
import { useEffect } from 'react';

import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';

const canUseApplePay = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const { ApplePaySession } = window;

  return Boolean(
    ApplePaySession &&
      typeof ApplePaySession.canMakePayments === 'function' &&
      typeof ApplePaySession.supportsVersion === 'function' &&
      ApplePaySession.canMakePayments() &&
      ApplePaySession.supportsVersion(4)
  );
};

const ApplePaySupport = ({ checkoutStore }) => {
  const { order } = checkoutStore;

  useEffect(() => {
    order.setApplePaySupportStatus({
      completed: true,
      supported: canUseApplePay(),
    });
  }, [order]);

  return null;
};

ApplePaySupport.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
};

export default inject('checkoutStore')(observer(ApplePaySupport));
